<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom">
          <div class="left">投诉单号</div>
          <div class="right">{{ item.mainComplainNumber }}</div>
        </div>
        <div class="receivingAgency border_bottom">
          <div class="left">审核人</div>
          <div class="right">
            {{ checkPerson.depts[0].orgName }}-{{ checkPerson.userInfo.name }}
          </div>
        </div>
      </div>
      <div class="uploadBox">
        <upload :imgUrl="imgUrl"></upload>
      </div>
      <div class="remark">
        <div class="titleName">审核内容</div>
        <div class="notAccepted">
          <van-field
            placeholder="请输入审核内容"
            type="textarea"
            :maxlength="total"
            @input="descInput"
            v-model="remark"
          />
          <span class="totalNum">{{ currentTotal }}/{{ total }}</span>
        </div>
      </div>
      <div class="btn">
        <div class="submit">
          <van-button @click="getAccept" type="primary">提交</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../../../service/modules/complaintApis";
import util from "../../../../utils/common";
import upload from "@/components/uploadCopy";
export default {
  components: {
    upload,
  },
  data() {
    return {
      total: 200,
      checkPerson:
        this.$store.state.complaint.userInfo ||
        util.getJsonLocal("userInfoComplaint"),
      orderNum: this.$router.currentRoute.query.orderNum,
      currentTotal: 0,
      remark: "",
      item: util.getJsonLocal("item"),
      isback:
        this.$store.state.complaint.isBackDetail || util.getJsonLocal("isBack"),
      // isShowBtn: false
      flag: false,
      imgUrl: [],
    };
  },
  mounted() {
    this.$on("fileUploadData", (val) => {
      this.imgUrl = val;
    });
  },
  created() {},
  methods: {
    descInput() {
      this.currentTotal = this.remark.length;
    },
    getAccept() {
      if (this.remark.trim().length == 0) {
        this.$Toast("审核内容不能为空");
        return;
      }
      let params = {
        id: this.item.id,
        reportContent: this.remark,
        urls: this.imgUrl,
      };
      // this.isShowBtn = true;
      if (this.flag === false) {
        this.flag = true;
        api.worker.reportDisagree(params).then((res) => {
          if (res.ret === 0) {
            this.$Toast("操作成功");
            // this.isShowBtn = false;
            if (
              localStorage.getItem("fromPath") &&
              localStorage.getItem("fromPath") == "home"
            ) {
              setTimeout(() => {
                localStorage.removeItem("fromPath");
                yyn.invokeJSB("closeWindow");
              }, 1500);
            } else {
              this.$router.go(-2);
            }
          } else {
            this.$Toast(res.msg);
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  height: 100%;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .uploadBox {
      margin-top: 20px;
    }
    .complaintInformation {
      width: 100%;
      .complaintNumber,
      .receivingAgency,
      .acceptedLaborNumber,
      .inadmissibleReason {
        display: flex;
        height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .border_bottom {
        border-bottom: 1px solid #eee;
      }
      .complaintNumber {
        .right {
          color: blue;
        }
      }
      .inadmissibleReason {
        .right {
          color: #ddd;
        }
      }
    }
    .remark {
      width: 100%;
      margin-top: 14px;
      position: relative;
      .titleName {
        color: #aaa;
        text-align: left;
      }
      .notAccepted {
        margin-top: 14px;
        .van-cell {
          font-size: 14px;
          background: #efeded;
          border-radius: 7px;
        }
      }
      .totalNum {
        position: absolute;
        right: 6px;
        bottom: 6px;
      }
    }
    .btn {
      margin-top: 30px;
      .van-button {
        width: 100%;
        border-radius: 7px;
        margin-top: 10px;
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
  }
}
</style>
